var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-avatar px",class:{ mobile: _vm.isMobile, small: _vm.small }},[_c('img',{attrs:{"src":_vm.src || _vm.images.avatar,"alt":"Avatar"},on:{"click":function($event){return _vm.$emit('click')},"error":function (ref) {
        var target = ref.target;

        target.src = _vm.images.avatar;
      }}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }